



































































































import { FormInput, Select } from '@/pages/profile/blocks';
import { Checkbox } from '@/components/form';
import { Button } from '@/pages/profile/components';
import { validationMixin } from 'vuelidate';
import { IWorkPlace } from '../types';
import { and, required, url } from 'vuelidate/lib/validators';
import { _util } from '@/tools/declare/global/$util';
import { differenceInDays } from 'date-fns';
import {mayBeEmpty} from "@/tools/validators";

export default {
  name: 'AddEditWorkPlaceBody',
  mixins: [validationMixin],
  components: {
    FormInput,
    Checkbox,
    Select,
    Button,
  },
  props: {
    workPlace: {
      type: Object,
      default: (self: any): IWorkPlace => ({
        region_id: null,
        is_inner_organizations: false,
        prof_sphere_id: undefined,
        site: '',
        duties: '',
        acceptance_date: '',
        dismissal_date: '',
        work_place: '',
        is_currently: false,
        position: '',
      }),
    },
    saveMethod: {
      type: Function,
    },
    works: {
      type: Array,
      default: [],
    },
    regions: {
      type: Array,
      default: [],
    },
    partners: {
      type: Array,
      default: [],
    },
    profSpheres: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dateMask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
      workPlaceData: this.workPlace,
      errors: [],
    };
  },
  computed: {
    currentRegion() {
      return Number(this.$store.state.regionProfile?.regionId);
    },
    workPlaceComputed: {
      get() {
        return this.workPlaceData;
      },
      set(value: IWorkPlace) {
        this.workPlaceData = value;
      },
    },
  },
  validations: {
    workPlaceComputed: {
      region_id: {
        required,
      },
      work_place: {
        required,
      },
      acceptance_date: {
        required,
        // TODO: я поправил валидацию дат, но в последствии надо переписать всё на валидационных хелперах из
        // tools/validations с динамическим выводом сообщений которые можно кастомно расположить в самом компоненте
        // p.s. нужно создать дикшенарь всех дефолтных сообщений и выводить их если в тз не указано обратное
        mask: and((value: string) => {
          return (
            value === '' ||
            _util.checkIsOutOfRangeDate(
                value,
                '1910-01-01',
                `${new Date().getFullYear()}-${
                    (String(new Date().getMonth() + 1)).length <= 1 ? '0'+(String(new Date().getMonth() + 1)) : (String(new Date().getMonth() + 1))

                }-${(String(new Date().getDate())).length <= 1 ? '0'+(String(new Date().getDate())) : (String(new Date().getDate()))}`,
                'DD.MM.YYYY'
            )
          );
        }),
      },
      dismissal_date: {
        required: async (value: string, context: any) => {
          return (await context.is_currently) ? true : required(value);
        },
        workDateBefore: async (value: string, context: any) => {
          const dates1 = value.split('.');
          const dates2 = context.acceptance_date.split('.');
          let tmp = '';
          tmp = dates1[2];
          dates1[2] = dates1[0];
          dates1[0] = tmp;
          tmp = dates2[2];
          dates2[2] = dates2[0];
          dates2[0] = tmp;
          if (context.is_currently) return true;
          return differenceInDays(new Date(...dates1), new Date(...dates2)) >= 0;
        },
        mask: and((value: string) => {
          return (
            value === '' ||
            _util.checkIsOutOfRangeDate(
              value,
              '1910-01-01',
              `${new Date().getFullYear()}-${
                  (String(new Date().getMonth() + 1)).length <= 1 ? '0'+(String(new Date().getMonth() + 1)) : (String(new Date().getMonth() + 1))

              }-${(String(new Date().getDate())).length <= 1 ? '0'+(String(new Date().getDate())) : (String(new Date().getDate()))}`,
              'DD.MM.YYYY'
            )
          );
        }),
      },
      position: {
        required,
      },
      site: {
        url,
      },
    },
  },
  watch: {
    ['workPlaceComputed.is_currently'](newValue: boolean) {
      if (!newValue) {
        this.$v.workPlaceComputed.dismissal_date.$reset();
        this.$set(this.workPlaceComputed, 'dismissal_date', '');
      }
    },
    ['workPlaceComputed.is_inner_organizations'](newValue: boolean) {
      if (!newValue) {
        this.$set(this.workPlaceComputed, 'work_place', '');
        this.$v.workPlaceComputed.work_place.$reset();
      }
    },
  },

  created() {
    this.$set(
      this.workPlaceComputed,
      'region_id',
      this.workPlaceComputed?.region_id || this.currentRegion
    );
  },

  methods: {
    resetYear() {
      if (
        this.workPlaceComputed.is_currently &&
        this.$v.workPlaceComputed.dismissal_date.$dirty
      ) {
        // this.$v.studyPlaceComputed.dismissal_date.$reset();
        this.$set(this.workPlaceComputed, 'dismissal_date', undefined);
      }
    },
    validate() {
      this.$v.workPlaceComputed.$touch();
      return this.$v.workPlaceComputed.$invalid;
    },
    collectData() {
      const data = {
        ...this.workPlaceComputed,
      };
      // TODO: update with conditions
      return data;
    },
    close() {
      this.$ui.$modal.close('AddEditWorkPlace');
    },
    save() {
      const isValid = this.validate();
      this.errors.splice(0, this.errors.length);
      if (!isValid) {
        const preparedData = this.collectData();
        Object.keys(preparedData).forEach((index) => {
          if (!preparedData[index]) delete preparedData[index];
        });
       // ...this.works,  -  работы которые куже есть
        this.saveMethod([preparedData])
          .then(() => {
            this.close();
          })
          .catch((err: Array<any>) => {
            const errorList = err.map((el) => el.msg);
            this.errors.push(...errorList);
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/work/components/AddEditWorkPlaceBody.vue